import { render, staticRenderFns } from "./index.vue?vue&type=template&id=553fec80&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=553fec80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553fec80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553fec80')) {
      api.createRecord('553fec80', component.options)
    } else {
      api.reload('553fec80', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=553fec80&scoped=true&", function () {
      api.rerender('553fec80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DwChartTitle/index.vue"
export default component.exports